<script setup lang="ts">
const route = useRoute();

await navigateTo(
  { path: '/vip/store', query: route.query },
  { replace: true, redirectCode: 301 },
);
</script>

<template>
  <div></div>
</template>
